// src/store/modules/chat.js  
const state = {  
  onlineCount: 0,  
  lastReceivedUser: '',  
  lastReceivedMessage: '',
  lastReceivedTitle:''
};  
  
const mutations = {  
  SET_ONLINE_COUNT(state, count) {  
    state.onlineCount = count;  
  },  
  SET_LAST_RECEIVED_USER(state, user) {  
    state.lastReceivedUser = user;  
  },  
  SET_LAST_RECEIVED_MESSAGE(state, message) {  
    state.lastReceivedMessage = message;  
  },  
  SET_LAST_RECEIVED_TITLE(state, title) {  
    state.lastReceivedTitle = title;  
  }  
};  
  
const actions = {  
  updateOnlineCount({ commit }, count) {  
    commit('SET_ONLINE_COUNT', count);  
  },  
  updateLastReceivedUser({ commit }, user) {  
    commit('SET_LAST_RECEIVED_USER', user);  
  },  
  updateLastReceivedMessage({ commit }, message) {  
    commit('SET_LAST_RECEIVED_MESSAGE', message);  
  },
  updateLastReceivedTitle({ commit }, title) {  
    commit('SET_LAST_RECEIVED_TITLE', title);  
  }    
};  
  
export default {  
  namespaced: true,  
  state,  
  mutations,  
  actions  
};


// WEBPACK FOOTER //
// ./src/store/modules/chat.js